import { render, staticRenderFns } from "./baoHu.vue?vue&type=template&id=228de562"
import script from "./baoHu.vue?vue&type=script&lang=js"
export * from "./baoHu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports